function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;


//////////////////
// WEBPACK FOOTER
// ./~/.deno/@babel+runtime@7.26.0/~/@babel/runtime/helpers/interopRequireDefault.js
// module id = 10
// module chunks = 0